
/* injects from baggage-loader */

import React, { Component } from 'react';
import {t} from "../../../helpers/translator";

class ErrorBetslipEvents extends Component {
    render () {
        return <div className="ticket-results-view-p">
            <div className="popup-message error"/>
            <h3>
                {t("The number of events can not be more than 16")}
            </h3>
        </div>;
    }
}

export default ErrorBetslipEvents;